import React from 'react';
import MenuNavigation, { IMenuItem } from '../components/MenuNavigation';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Home.css';
import '../assets/styles/menu.css';
import { Container } from 'react-bootstrap';
import MainHeader from '../components/MainHeader';
import DesktopMenu from '../components/DesktopMenu';
import history from './History';
import * as operatorApi from '../api/CollectionpointOperators';
import * as sortersApi from '../api/Sorters';
import * as sortCodesApi from '../api/SortCodes';
import { getBackendVersion } from '../api/Version';
import BrowseReceptionReport from './ReceptionReports/BrowseReceptionReport';
import ManageReceptionReport from './ReceptionReports/ManageReceptionReport';
import ImportHandlerReport from './HandlerReports/ImportHandlerReport';
import BrowseHandlerReport from './HandlerReports/BrowseHandlerReport';
import ManageCollectionpoints from './Settings/ManageCollectionpoints';
import ImportSortSummaryReport from './SortSummaryReports/ImportSortSummaryReport';
import ManageRecyclingFeeReports from './RecyclingFees/ManageRecyclingFeeReports';
import SummaryReport from './SortSummaryReports/SummaryReport';
import BrowseSortSummaryReport from './SortSummaryReports/BrowseSortSummaryReport';
import SummaryReportOptions from './SortSummaryReports/SummaryReportOptions';
import CompareReports from './SortSummaryReports/CompareReports';
import { injectIntl } from 'react-intl';
import { MsalContext, AuthenticatedTemplate } from '@azure/msal-react';
import ErrorBoundary from '../util/ErrorBoundary';

export interface IHomeState {
  activePage: string;
}

export interface IHomeProps {
  intl: any;
}

class Home extends React.Component<IHomeProps, IHomeState> {

  static contextType = MsalContext;

  pages : IMenuItem[] = [
    {text: 'reports.todesktop', icon: 'chevron-circle-left', page: <DesktopMenu changePage={(activePage) => this.setState({activePage})}/>},
    {text: 'receptionreports.header', icon: '', page: <div/>},
    {text: 'handlerreports.import', icon: 'file-import', page: <ImportHandlerReport/>},
    {text: 'handlerreports.browse', icon: 'copy', page: <BrowseHandlerReport/>},
    {text: 'receptionreports.browse', icon: 'file-export', page: <BrowseReceptionReport/>},
    {text: 'receptionreports.manage.header', icon: '', page: <div/>},
    {text: 'receptionreports.manager', icon: 'cogs', page: <ManageReceptionReport/>},
    {text: 'recyclingfeereports.header', icon: 'coins', page: <ManageRecyclingFeeReports/>},
    {text: 'settings.collectionpoints', icon: 'recycle', page: <ManageCollectionpoints/>},
    {text: 'sortsummaryreports.header', icon: '', page: <div/>},
    {text: 'sortsummaryreports.import', icon: 'file-upload', page: <ImportSortSummaryReport/>},
    {text: 'sortsummaryreports.monthly', icon: 'calendar-alt', page: <SummaryReport/>},
    {text: 'sortsummaryreports.browse', icon: 'money-bill-wave', page: <BrowseSortSummaryReport/>},
    {text: 'sortsummaryreports.settings', icon: 'toolbox', page: <SummaryReportOptions/>},
    {text: 'sortsummaryreports.compare', icon: 'equals', page: <CompareReports/>}
  ];

  constructor(props: any) {
    super(props);
    this.state = {
      activePage: 'reports.todesktop'
    }
  }

  componentDidMount = async () => {
    const isAuthenticated = this.context.accounts.length > 0;
    if (!isAuthenticated) {
      history.push('/');
    }
    else {
      // start loading data in the background to save time in the report pages.
      getBackendVersion(true);
      operatorApi.getCollectionpointOperators(true); // Force database update from backend
      operatorApi.getAllCollectionpointInfo(true);
      sortersApi.getSorters(true);
      sortCodesApi.getSortCodes(true);
    }
  }

  render() {
    return (
      <AuthenticatedTemplate>
        <Container className="Home">
          <div className="Menu">
            <div className="LeftPanel">
              <MenuNavigation
                activePage={this.state.activePage}
                pages={this.pages}
                changePage={(activePage) => this.setState({activePage})}
              />
            </div>
            <div className="RightPanel">
              <MainHeader/>
              <div className="MainView">
                <ErrorBoundary>
                  {this.pages[this.pages.findIndex((p) => p.text === this.state.activePage)].page}
                </ErrorBoundary>
              </div>
            </div>
          </div>
        </Container>
      </AuthenticatedTemplate>
    );
  }
}

export default injectIntl(Home);
